import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

export const StyledCloseIcon = styled(CloseIcon)(() => ({
    cursor: 'pointer',
    color: 'grey',
}));
